import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/common/claim_available.png'
import _imports_1 from '@/assets/common/claim_not_available.png'


const _hoisted_1 = { class: "cardContainer" }
const _hoisted_2 = { class: "dayCard" }
const _hoisted_3 = { class: "dayImage" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  class: "dateText",
  style: {"color":"#aeaeae"}
}
const _hoisted_7 = {
  class: "availableTitle",
  style: {"color":"#d1bdac"}
}
const _hoisted_8 = { class: "availableTitle glowText" }
const _hoisted_9 = { class: "givenValueText" }
const _hoisted_10 = { class: "glowText" }

import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackCard',
  props: {
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const clickOnButton = () => {
    emits('getClaim')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          class: "dayRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, {
              style: {"width":"100%"},
              justify: "center"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "4",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          (index == 0 && __props.showClickButton)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["day-num", { 'day-num-disable': !(index == 0 && __props.showClickButton) }])
                          }, _toDisplayString(index + 1), 3)
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dayFormat)(i.date, 0)), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["dateText", {
                                'date-text-active': index === 0 && __props.showClickButton,
                                'date-text-inactive': index === 0 && !__props.showClickButton
                            }])
                        }, _toDisplayString(_unref(formatCurrency)(i.amount)), 3)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "24",
          class: "availbleContent"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, { style: {"margin":"5px 0 0","border-bottom":"1px solid #c19a6ba6"} }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  style: {"text-align":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('activity.available')) + ": ", 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString('R$ ' + _unref(formatCurrency)(__props.availableValue)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  style: {"display":"flex","justify-content":"center","align-items":"center"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["click_btn", { 'btn-disabled': !__props.showClickButton }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showClickButton && clickOnButton()))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('activity.click')), 1)
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t('activity.given')) + ": ", 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatCurrency)(__props.givenValue)), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})